export const AWSWSAPIGATEWAY = process.env.REACT_APP_AWSWSAPIGATEWAY;
export const AWSAPIGATEWAY = process.env.REACT_APP_AWSAPIGATEWAY;
export const AWSAPIKEY = process.env.REACT_APP_API_KEY;
